import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {SpecialTechnologyInfoDTO } from "../special-technologies-DTO";
import SpecialTechnologyForm from "../special-technologies-form/special-technologies-form";


interface Props {
  item: SpecialTechnologyInfoDTO;
  onClose: () => void;
}

const CardSpecialTechnologies = ({ onClose, item }: Props) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    onClose();
  };

  return (
    <div>
      {isModalOpen && (
        <div className="modal-background">
          <SpecialTechnologyForm contactId={item.id} onClose={handleCloseModal} />
        </div>
      )}
      <div className="flex-row card-dealer" onClick={handleOpenModal}>
        <div className="flex-column infos">
          <h3>{item.specialTechnologyTitle || "-"}</h3>
          <div className="custom-line-hr" />
          <p>
            {item.specialTechnology || "-"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardSpecialTechnologies;
